import PropTypes from "prop-types"
import React from "react"

import BaseAvatar from "src/components/BaseAvatar"
import Button from "src/components/Button"

import AuthInterstitialLayout from "./AuthInterstitialLayout"

const GuestSignInNudge = ({
  account,
  authPhotoUrl,
  onSignIn,
  onSkip,
  signInUrl,
}) => {
  const greetingName = account.name || account.email

  return (
    <AuthInterstitialLayout
      authPhotoUrl={authPhotoUrl}
      title={`Welcome back ${greetingName}!`}
      subtitle="Your email is already registered. Sign in to make signing your agreement even faster."
    >
      <div className="mx-auto w-full xl:w-3/4">
        <div className="my-6 flex items-center justify-between gap-4 rounded-lg border px-4 py-4 shadow-md">
          <div className="flex items-center gap-3">
            <BaseAvatar
              src={account.thumbnailUrl}
              name={greetingName}
              backgroundColor={
                account.thumbnailUrl ? undefined : account.avatarBackgroundColor
              }
            />
            <div className="flex flex-col">
              <span className="font-semibold text-gray-900">
                {greetingName}
              </span>
              {account.name && (
                <span className="text-gray-700">{account.email}</span>
              )}
            </div>
          </div>
          <span className="font-semibold text-teal-600">Existing account</span>
        </div>

        <a
          href={signInUrl}
          className="btn btn-primary w-full"
          onClick={onSignIn}
        >
          Sign In
        </a>

        <div className="mt-3">
          <Button variant="link" fullWidth onClick={onSkip}>
            Skip (Not Recommended)
          </Button>
        </div>
      </div>
    </AuthInterstitialLayout>
  )
}

GuestSignInNudge.propTypes = {
  account: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string,
    avatarBackgroundColor: PropTypes.string,
  }).isRequired,
  authPhotoUrl: PropTypes.string,
  onSignIn: PropTypes.func,
  onSkip: PropTypes.func.isRequired,
  signInUrl: PropTypes.string.isRequired,
}

export default GuestSignInNudge
